import { Model } from '@topwrite/common';
import { Editor as SlateEditor } from 'slate';
import PlatePlugin, { Decorate } from '../components/editor/plate-plugin';

interface EditorType {
    plugins: Map<PlatePlugin, PlatePlugin>;
    decorates: Map<Decorate, Decorate>;
    instance: SlateEditor | null;
}

class Editor extends Model<EditorType> {

    initialState = {
        plugins: new Map(),
        decorates: new Map(),
        instance: null,
    };

    *setInstance(instance: SlateEditor | null) {
        yield this.setState(state => {
            state.instance = instance;
        });
    }

    *addPlugin(plugin: PlatePlugin) {
        yield this.setState(({ plugins }) => {
            plugins.set(plugin, plugin);
        });
    }

    *removePlugin(plugin: PlatePlugin) {
        yield this.setState(({ plugins }) => {
            plugins.delete(plugin);
        });
    }

    *addDecorate(decorate: Decorate) {
        yield this.setState(({ decorates }) => {
            decorates.set(decorate, decorate);
        });
    }

    *removeDecorate(decorate: Decorate) {
        yield this.setState(({ decorates }) => {
            decorates.delete(decorate);
        });
    }
}

export const editor = new Editor();
